import React, { useState, useRef, useCallback, useLayoutEffect } from "react";
import { useLocation } from "react-router";
import qs from "qs";

import styles from "./mainScreen.module.scss";

import Card from "../../components/card/Card";
import PaymentForm from "../../components/PaymentForm";
import Footer from "../../components/Footer";
import ProductSummary from "../../components/ProductSummary";
import { useGlobalStore } from "../../stores/globalStore";

const initialState = {
  cardNumber: "#### #### #### ####",
  cardHolder: "FULL NAME",
  cardExpiry: "",
  cardCvv: "",
  isCardFlipped: false,
};

const MainScreen = () => {
  const [state, setState] = useState(initialState);
  const [currentFocusedElm, setCurrentFocusedElm] = useState(null);
  const location = useLocation();
  const setShowShippingInfo = useGlobalStore(
    (state) => state.setShowShippingInfo
  );

  useLayoutEffect(() => {
    if (location.search) {
      // ?foo=bar
      const params = qs.parse(location.search.substring(1));

      if (params.type && params.type === "digital") {
        setShowShippingInfo(false);
      }
    }
  }, [location.search]);

  const updateStateValues = useCallback(
    (keyName, value) => {
      setState({
        ...state,
        [keyName]: value || initialState[keyName],
      });
    },
    [state]
  );

  // References for the Form Inputs used to focus corresponding inputs.
  let formFieldsRefObj = {
    cardNumber: useRef(),
    cardHolder: useRef(),
    cardDate: useRef(),
    cardCvv: useRef(),
  };

  let focusFormFieldByKey = useCallback((key) => {
    formFieldsRefObj[key].current.focus();
  });

  // This are the references for the Card DIV elements.
  let cardElementsRef = {
    cardNumber: useRef(),
    cardHolder: useRef(),
    cardDate: useRef(),
  };

  let onCardFormInputFocus = (_event, inputName) => {
    const refByName = cardElementsRef[inputName];
    setCurrentFocusedElm(refByName);
  };

  let onCardInputBlur = useCallback(() => {
    setCurrentFocusedElm(null);
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.products}>
          <ProductSummary />
        </div>

        <div className={styles.payment}>
          <PaymentForm
            cardExpiry={state.cardExpiry}
            onUpdateState={updateStateValues}
            cardNumberRef={formFieldsRefObj.cardNumber}
            cardHolderRef={formFieldsRefObj.cardHolder}
            cardDateRef={formFieldsRefObj.cardDate}
            onCardInputFocus={onCardFormInputFocus}
            onCardInputBlur={onCardInputBlur}
          >
            <Card
              cardNumber={state.cardNumber}
              cardHolder={state.cardHolder}
              cardExpiry={state.cardExpiry}
              cardCvv={state.cardCvv}
              isCardFlipped={state.isCardFlipped}
              currentFocusedElm={currentFocusedElm}
              onCardElementClick={focusFormFieldByKey}
              cardNumberRef={cardElementsRef.cardNumber}
              cardHolderRef={cardElementsRef.cardHolder}
              cardDateRef={cardElementsRef.cardDate}
            ></Card>
          </PaymentForm>
        </div>

        <footer className={styles.footer}>
          <Footer />
        </footer>
      </div>
    </div>
  );
};

export default MainScreen;
